export class CUSTOMER {
    public static MODEC = '09e51022-a277-425c-aba8-8663b7ba69e6'
    public static PORT_HOUSTON = 'c640d4bf-b211-4db2-aa22-7397332e927f'
    public static PHDSOFT = '371cd73be9d34ed49535c60a8e166384'
    public static WIT = '421daf30-20e0-4ff1-a19b-9cc0170c3cd2'
    public static TANGER_MED = '07fcfee6-e7fa-4234-a7a0-41e369146b9f'
}
